"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isScheduler = isScheduler;
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/util/isScheduler.js
// module id = 120
// module chunks = 0